import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { withTheme } from 'styled-components';
import { AbstractChart } from 'containers/charts/AbstractChart';

class BoxPlotSmall extends Component {
    shouldComponentUpdate(nextProps) {
        if (isEqual(nextProps.data, this.props.data)) {
            return false;
        }
        return true;
    }

    render() {
        const { labelTitle, data: seriesData } = this.props;
        return (
            <AbstractChart exportName={this.props.exportName} config={{
                chart: {
                    margin: [9, 0, 9, 0],
                    spacing: [0, 0, 0, 0],
                    backgroundColor: 'transparent',
                    height: '70px',
                    type: 'boxplot',
                    inverted: true
                },
                title: {
                    text: ''
                },
                exporting: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                legend: {
                    enabled: false,
                    itemStyle: {
                        color: this.props.theme.colors.darkgray
                    }
                },
                xAxis: {
                    visible: false,
                    labels: {
                        enabled: true
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                },
                yAxis: {
                    visible: false,
                    endOnTick: false,
                    startOnTick: false,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    tickPositions: [0]
                },
                tooltip: {
                    animation: true,
                    outside: true,
                    useHTML: true,
                    followPointer: true,
                },
                plotOptions: {
                    series: {
                        animation: {
                            duration: this.props.animateDuration
                        },
                        pointPadding: 0.05,
                        groupPadding: 0.1,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            enabled: false
                        }
                    }
                },
                series: [{
                    name: labelTitle,
                    color: this.props.theme.charts.sparkline,
                    fillColor: `${this.props.theme.charts.boxPlotFill}`,
                    data: [[
                        seriesData.min,
                        seriesData.q25,
                        seriesData.median,
                        seriesData.q75,
                        seriesData.max
                    ]],
                    tooltip: {
                        headerFormat: ''
                    }
                }]
            }} />
        );
    }
}

export default withTheme(BoxPlotSmall);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/CalloutBoxPlot.js